module.exports = __webpack_public_path__ + "static/img/partner3.38b8659.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner3.png
// module id = GUlf
// module chunks = 0